<template>
  <div>
    <Message type="info">
      キャンペーンの作成が完了しました。
      <br />
      この後は、応募グループの設定をしましょう！
    </Message>

    <div class="campaign-create-completed">
      <Panel>
        <div class="campaign-completed-description">
          <div class="campaign-completed-title">応募の振り分けをしない場合</div>
          自動生成された応募グループ「デフォルト」の編集画面から、
          <br />
          当選者数を設定してください。
          <div class="campaign-completed-title">応募の振り分けをする場合</div>
          応募の振り分けをする場合は、応募グループを追加する必要があります。
          <br />
          詳しくは
          <a href="https://help-atelu.comnico.jp/2fd05779-6738-801e-9d9e-ec229b63fe94" target="_blank"> こちら </a>
          をご確認ください。
          <div class="campaign-completed-tips">
            <Tips> キャンペーン一覧でキャンペーンタイトルをクリックすると、応募グループに移動できます。 </Tips>
          </div>
        </div>
      </Panel>
    </div>

    <div class="campaign-completed-footer">
      <el-button @click="goToApplicants"> 応募グループ一覧へ </el-button>
      <el-button @click="close"> 閉じる </el-button>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import Message from '@/client/components/_atoms/Message.vue'
import Panel from '@/client/components/_atoms/Panel.vue'
import Tips from '@/client/components/_atoms/Tips.vue'
import { CampaignForm, useCampaignDialogStore } from '@/client/store/useCampaignDialogStore'

export default defineComponent({
  components: {
    Icon,
    Message,
    Panel,
    Tips
  },
  computed: {
    ...mapState(useCampaignDialogStore, ['campaign_id', 'form']),
    isInstagramInstantwin() {
      const vm = this as typeof this & { form: CampaignForm }
      return vm.form.target_sns === 'instagram' && vm.form.campaign_type === 'instantwin'
    }
  },
  methods: {
    ...mapActions(useCampaignDialogStore, ['reset']),
    /**
     * 応募グループ画面へ
     */
    goToApplicants() {
      // Instagram インスタントウィンの場合は専用の応募グループ一覧へ遷移
      if (this.isInstagramInstantwin) {
        this.$router.push({
          name: 'instagram_instantwin_prizes',
          params: {
            campaignId: String(this.campaign_id)
          }
        })

        this.reset()

        return
      }

      const target_sns_maps: Record<string, string> = {
        twitter: 'twitter_campaigns_prizes',
        instagram: 'instagram_campaigns_prizes',
        tiktok: 'tiktok_campaigns_prizes'
      }

      const routeName = target_sns_maps[this.form.target_sns]

      if (routeName) {
        this.$router.push({
          name: routeName,
          params: {
            campaignId: String(this.campaign_id)
          }
        })
      }

      this.reset()
    },

    close(payload: unknown) {
      this.$emit('close', payload)
      return payload
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.campaign-create-completed {
  margin-top: $spacing-unit * 2;

  .campaign-completed-description {
    padding: $spacing-unit * 3 0;
  }

  .campaign-completed-title {
    margin-bottom: $spacing-unit;
    font-size: $font-large-size;
    font-weight: bold;

    &:not(:first-child) {
      margin-top: $spacing-unit * 2;
    }
  }

  .campaign-completed-tips {
    margin-top: $spacing-unit * 2;
  }
}

.campaign-completed-footer {
  margin-top: $spacing-unit * 3;
  text-align: right;

  .el-button .mdi {
    margin-right: 0;
  }
}
</style>
